import { render, staticRenderFns } from "./RedemptionsPagesContainer.vue?vue&type=template&id=4fb865b1&"
import script from "./RedemptionsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./RedemptionsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports